export const trialTypes = {
  ALL: "ALL",
  BILLABLE: "BILLABLE",
  IN_FREE_TRIAL: "IN_TRIAL",
  TRIAL_EXPIRED: "TRIAL_EXPIRED",
  OTHERS: "OTHERS"
};
